$ = require 'jquery'
Browser = require '@trello/browser'
f = require 'effing'
Keys = require 'data/keys'
Layout = require 'views/lib/layout'
PopOverReact = require 'views/lib/pop-over-react'
Promise = require 'bluebird'
View = require 'view'
React = require 'react'
ReactDOM = require 'react-dom'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
WindowSize = require 'lib/window-size'
ReactWrapper = require 'lib/react/backbone-view-wrapper'
xtend = require 'xtend'
_ = require 'underscore'

HEADER_HEIGHT = 44

module.exports = new class
  $body = null
  $po = null
  elem = null
  fnOnHide = null
  positionInterval = null

  shortcut: (key, event) ->

    switch key
      when Keys.Escape
        @popView()
        # we assume popovers are always the topmost item, so if we close them on Esc
        # it is safe to stop the event from bubbling, this was added specifically to
        # handle the case where a Power-Up has a modal up, and a popover is opened above it
        event.stopImmediatePropagation()
        ["Esc - Pop Pop-over View", "Pop Over"]

  constructor: ->
    @argsStack = []
    @position = {}
    @isVisible = false
    @hardToClose = false
    @displayType = ''

  init: ->
    $body = $('body')
    $po = $('.pop-over')

    # Popover Events
    $body.on('dialog-show', @maybeHide.bind(this))
    $body.on('dialog-hide', @maybeHide.bind(this))

  maybeHide: (e, { closePopup } = { closePopup: true }) ->
    if(@isVisible && closePopup)
      @hide()

  contains: (el) ->
    $.contains($po[0], el)

  toggledBy: (el) ->
    _.any(@argsStack, (arg) -> arg.elem == el)

  # Make sure the popover is still visible when the window is resized
  onWindowResize: ->
    return if !@isVisible

    @load @argsStack.pop()

  resetTopWhenBeyondBottom: (po_top, po_bottom, po_height) ->
    _po_top = po_top
    windowHeight = $(window).height()
    if WindowSize.fLarge or WindowSize.fExtraLarge
      s_height = windowHeight + $(window).scrollTop()
      if po_bottom > s_height
        _po_top = s_height - po_height - 8
      if po_height > s_height - HEADER_HEIGHT
        _po_top = HEADER_HEIGHT

    return _po_top

  # Return the new position of the popover
  calcPos: (args) ->
    windowWidth = $(window).width()
    windowHeight = $(window).height()

    if args.maxWidth?
      if args.maxWidth > windowWidth
        $po.width(windowWidth - 16)
      else
        $po.width(args.maxWidth)

    else
      $po.width("")

    max_right = windowWidth
    w_height = windowHeight
    po_width = $po.outerWidth()

    elementIsVisible = args.elem? && $(args.elem).is(':visible')

    if elementIsVisible

      if args.top?
        top = args.top
      else if args.elem? # would be in a pretty bad state if this were false…
        top = $(args.elem).outerHeight() + 6
      else
        top = 35 # an arbitrary default… could break w/o it.

      if args.alignRight
        el_left = $(args.elem).offset().left + $(args.elem).outerWidth() - po_width
      else
        el_left = $(args.elem).offset().left
      el_top = $(args.elem).offset().top + top

    else if args.clientx? && args.clienty?
      el_left = args.clientx
      el_top = args.clienty

    # magic number alert! 68 is the height of the global header and a little
    # extra padding for the bottom. we don't want to pop over to overflow past
    # the bottom of the screen.
    poMaxHeight = w_height - 68
    if !args.hideHeader
      poMaxHeight -= $po.find('.js-pop-over-header').outerHeight()

    # if there is no hook element or it's hidden, don't bother try to position anything
    # prevents wacky jump when trying to change label names and some otherview pops.
    # if we are clicking the board to add a list (clientx, clienty), DO show the board
    if (
      !(args.clientx? && args.clienty?) &&
      (!elementIsVisible || !_.include(['block', 'inline-block', 'inline', 'table-cell', 'flex'], $(args?.elem).css('display')))
    )
      return

    # TOP

    # ensure that the top of the element is visible
    po_top = if el_top > 0 then el_top else 5
    po_height = $po.outerHeight()
    po_bottom = po_top + po_height

    po_top = @resetTopWhenBeyondBottom(po_top, po_bottom, po_height)

    # LEFT

    po_left = if el_left > 0 then el_left else 5
    el_right = po_left + po_width + 16

    # we want to ensure the right corner is on the screen
    if el_right > max_right
      # move the element back onto the screen
      po_left = max_right - (po_width + 5)

    # make sure the original args.elem is not overlaid
    if args.elem && po_top <= $(args.elem).offset().top + $(args.elem).outerHeight() && po_bottom >= $(args.elem).offset().top
      # reposition the popup above the target element
      po_top = $(args.elem).offset().top - po_height - 6 # 6 is the same padding used above
      # ensure that the top of the popup is top above the screen
      if po_top < HEADER_HEIGHT
        po_top = HEADER_HEIGHT
        po_bottom = po_top + po_height
      else
        po_bottom = po_top + po_height
        po_top = @resetTopWhenBeyondBottom(po_top, po_bottom, po_height)

    {
      left: po_left
      top: po_top
      contentHeight: poMaxHeight
    }

  # Loads the supplied view into $po and sets all the applicable class fields
  load: (args) ->
    # We have to set PopOver.view. Hopefully some day we won't have to do this,
    # but for now the rest of the app assumes we're wont to do it.
    @view = args.view
    @hardToClose = args.hardToClose
    # Add special CSS classes for special types of popovers
    @displayType = args.displayType
    $po.addClass(@displayType)

    #
    # React!
    #

    if !React.isValidElement args.reactElement
      throw new Error("PopOver args.reactElement has to be a react element")

    children =
      if _.last(@argsStack)?.keepInDOM
        oldChildren = _.chain(@argsStack).filter((args) -> args.keepInDOM).pluck('reactElement').value()
        oldChildren.concat(args.reactElement)
      else
        [args.reactElement]

    props =
      key: "PopOver"
      onBack: if @argsStack.length > 0 then => @popView() else null
      onClose: f @, 'hide'
      getViewTitle: args.getViewTitle
      hasSafeViewTitle: args.hasSafeViewTitle
      hideHeader: args.hideHeader

    @por = ReactDOM.render(
      React.createElement(PopOverReact, props, children),
      $po[0]
    )

    show = =>
      # Position the popover. We do this here because we need to render it first to calculate its position.
      @position = @calcPos(args) ? @position

      $po.css
        left: @position.left
        top: @position.top

      $po.find('.js-pop-over-content').css
        maxHeight: @position.contentHeight

      $po.addClass 'is-shown'
      $po.trigger 'is-shown'

    if args.showImmediately
      show()
    else
      _.defer show

    @argsStack.push args

  # We have legacy code that puts some properties on the view, but now we expect these properties on args.
  # If there are conflicts, args takes precedence.
  extractViewArgs: (args) ->
    # If there's a react element already, then it's using the new style
    return args if args.reactElement?

    # Sometimes we just get a view
    if !args.view?
      args = { view: args }

    # If you pass a view class, instantiate it here
    if _.isFunction(args.view)
      args.view = new args.view(args.options ? {})

    # Now we have the view, check that it's a backbone view
    if !(args.view instanceof View)
      throw new Error("PopOver args.view has to be a backbone instance")

    extractViewFunction = (view, name) ->
      if _.isFunction(view[name]) then f(view, name)

    args.reactElement = React.createElement ReactWrapper, { key: args.view.cid, view: args.view }

    xtend {
        maxWidth: args.view.maxWidth
        displayType: args.view.displayType
        keepInDOM: args.view.keepInDOM
        hideHeader: args.view.hideHeader
        getViewTitle: extractViewFunction(args.view, 'getViewTitle')
        hasSafeViewTitle: args.view.hasSafeViewTitle
        willBePushedDown: extractViewFunction(args.view, 'willBePushedDown')
        willBePopped: extractViewFunction(args.view, 'willBePopped')
      }, args

  show: (args) ->
    # reset
    if !args.keepEdits
      Layout.cancelEdits(args.elActive)

    @reset()

    @load(@extractViewArgs(args))

    $body.trigger 'popover-show', { elem: args.elem }

    _.defer =>
      if $po.find('.js-autofocus').length > 0
        return if (Browser.isTouch() && $po.find('.js-autofocus:first').hasClass('js-no-touch-autofocus'))
        $po.find('.js-autofocus:first').focus().select()

    @isVisible = true
    args.shown?($po)
    fnOnHide = args.hidden

    @positionInterval = setInterval(@checkPosition.bind(@), 150)

    UserInput.addHandler(@, {
      scope: 'popover'
      modal: true
    })

    return

  # We don't really know what's going on in the popover; it might re-render and
  # get bigger than it is right now.  The simplest thing we can do is
  # periodically check and see if we've expanded beyond the bottom of the screen
  # and if so, move the popover up until everything is visible again
  # Also, they might have scrolled and made the popover go of the screen
  checkPosition: ->
    if !@isVisible
      clearInterval(@positionInterval)
      return

    popoverTop = $po.offset().top
    windowScrollTop = $(window).scrollTop()
    if popoverTop == windowScrollTop
      # We can't move the dialog up anymore; don't even bother
      return

    windowHeight = $(window).height()
    popoverHeight = $po.outerHeight()

    if popoverTop < windowScrollTop && popoverHeight <= windowHeight
      # They've scrolled down, keep the popover in view
      $po.css({ top: windowScrollTop })
      return

    if popoverTop + popoverHeight > windowScrollTop + windowHeight
      # The popover is extending beyond the bottom of the screen
      newTop = windowScrollTop + Math.max(0, windowHeight - popoverHeight)
      if newTop != popoverTop
        $po.css
          top: newTop

  pushView: (args) ->
    @clearDisplayTypes()

    oldArgs = _.last(@argsStack)
    oldArgs?.willBePushedDown?()

    @load(@extractViewArgs(args))

    if $po.find('.js-autofocus').length > 0
      return if (Browser.isTouch() && $po.find('.js-autofocus:first').hasClass('js-no-touch-autofocus'))
      setTimeout =>
        $po.find('.js-autofocus:first').focus().select()
      , 10

  popView: (depth = 1) ->
    @clearDisplayTypes()

    for i in [0...depth]
      oldArgs = _.last(@argsStack)
      oldArgs?.willBePopped?()
      oldArgs?.reactElement.props?.view?.remove()

      @argsStack.pop()

      if !_.last(@argsStack)?
        @hide()
        return

    # reload view without rerendering so we don't lose any in-progress input
    args = @argsStack.pop()
    args?.willBePushedUp?()
    @load args

    # wait to focus input because it stops the animation if we
    # focus while animating
    if $po.find('.js-autofocus').length > 0
      return if (Browser.isTouch() && $po.find('.js-autofocus:first').hasClass('js-no-touch-autofocus'))
      setTimeout =>
        $po.find('.js-autofocus:first').focus().select()
      , 10

  toggle: (args) ->
    # We want to hide when we're triggered on the same element. However,
    # the elem argument can either be a jQuery selection or a normal DOM
    # element, so we normalize here.
    isSameElement = (e1, e2) ->
      e1 && e2 && $(e1)[0] == $(e2)[0]

    if _.last(@argsStack) && isSameElement(_.last(@argsStack).elem, args.elem)
      @hide()
    else
      @show(args)

  hide: ->
    clearInterval(@positionInterval)

    $po.removeClass('is-shown')

    $body.trigger 'popover-hide', { elem: _.last(@argsStack)?.elem }

    @reset()

    if $po?[0]
      ReactDOM.unmountComponentAtNode($po[0])

  reset: ->
    @clearDisplayTypes()

    for args in @argsStack by -1
      args.willBePopped?()
      args.reactElement.props?.view?.remove()

    UserInput.removeHandlerScope 'popover_view'
    UserInput.removeHandler @

    # Other views reference PopOver.view.
    @view = null

    @argsStack = []
    @isVisible = false
    @hardToClose = false
    @por = null
    fnOnHide?($po)
    fnOnHide = null

  clearDisplayTypes: ->
    classes = [
      'mod-mini-profile'
      'mod-avdetail'
      'mod-search-over'
      'mod-no-header'
      'mod-reaction-selector'
      @displayType
    ]
    $po.removeClass(classes.join(' '))

  clearStack: ->
    @argsStack = []



// WEBPACK FOOTER //
// ./app/scripts/views/lib/pop-over.coffee